import { useQuery } from '@tanstack/react-query';
import ContactApi from '../apis/contact_api';

export const contactKeys = {
  all: ['contacts'],
  list: (search: string) => [...contactKeys.all, 'list', search],
  detail: (contactId: number) => [...contactKeys.all, 'detail', contactId],
};

export function useContacts(search: string) {
  return useQuery({
    queryKey: contactKeys.list(search),
    queryFn: async () => ContactApi.getContactsForUser(search),
  });
}

export function useContact(contactId: number) {
  return useQuery({
    queryKey: contactKeys.detail(contactId),
    queryFn: async () => ContactApi.getContactById(contactId),
    enabled: !!contactId,
  });
}
